import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { BaseFlex } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const SearchContainer = styled.div<{ isDisabled: boolean }>`
    .ListItemsContainer {
        overflow: auto;
        max-height: 280px;
        z-index: 2;
        box-sizing: border-box;
    }
    .AutoCompleteContainer {
        padding: 0;
        transform: initial;

        .input-container {
            background-color: ${({ isDisabled }) => (isDisabled ? colorsPalettes.bluegrey[200] : "initial")};
        }

        input::placeholder {
            color: ${colorsPalettes.carbon[400]};
        }

        path {
            fill: ${colorsPalettes.carbon[300]};
        }
    }
`;

export const SearchContainerWithBorder = styled.div<{ hasBorder: boolean }>`
    .ScrollArea {
        min-height: 48px;
        max-height: 248px !important;
        border: 1px solid ${colorsPalettes.carbon[300]};
        border-bottom: none;
        box-sizing: border-box;
    }
    > div > div > div:last-of-type {
        border: ${({ hasBorder }) => (hasBorder ? `1px solid ${colorsPalettes.carbon[300]}` : "none")};
    }
`;

export const InviteTitle = styled.div`
    margin-bottom: 16px;
    ${setFontVariant("body1", colorsPalettes.carbon["500"])};
    font-weight: 500;
`;

export const ViewerItem = styled(BaseFlex)<{ isActive: boolean }>`
    column-gap: 8px;
    max-height: 44px;
    padding: 10px 16px;
    ${setFontVariant("body2")};
    border-bottom: 1px solid ${colorsPalettes.carbon[100]};
    box-sizing: border-box;
    background-color: ${({ isActive }) => (isActive ? colorsPalettes.carbon[25] : colorsPalettes.carbon[0])};

    &:hover {
        background-color: ${colorsPalettes.carbon[25]};
    }
`;

export const IconWrapper = styled(BaseFlex)`
    column-gap: 12px;

    .SWReactIcons {
        width: 14px;
        height: 14px;

        path {
            fill: ${colorsPalettes.carbon[200]};
        }
    }
`;

export const ViewerItemEmail = styled.div`
    max-width: 340px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const ButtonWrapper = styled.div`
    .SWReactIcons {
        width: 9px;
        height: 9px;
    }
`;

export const ErrorMessageContainer = styled(BaseFlex)`
    margin-top: 4px;
    color: ${colorsPalettes.red[400]};
`;

export const ErrorLink = styled.a`
    color: ${colorsPalettes.red[400]};
    text-decoration: underline;
`;
